import React, { useState, useEffect } from "react";
import 'react-modal-video/scss/modal-video.scss';
import { Modal } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';
import { isMobile } from "react-device-detect";
import ReactPlayer from 'react-player/lazy'
import getVideoId from 'get-video-id';


import "./FullWidthVideo.scss"

const PlayVideo = (props) => {
    const [ref, inView] = useInView({
        threshold: 0,
        triggerOnce: true,
    });
    //const [show, setShow] = useState(props.isOpen ? props.isOpen : false);
    const [fullscreen, setFullscreen] = useState(true);

    //VIDEO GTM TRACKING
    const url = typeof window !== 'undefined' ? window.location.href : '';

    useEffect(() => {

        if (props.isOpen === true) {
            if (typeof window !== 'undefined') {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Video Play Btn',
                    'formType': url,
                    'formId': 'Video Play',
                    'formName': 'Video',
                    'formLabel': 'Video'
                });
            }
        }
    }, [props]);

    // const trackerVideo = (event) => {
    //     if (typeof window !== 'undefined') {
    //         window.dataLayer = window.dataLayer || [];
    //         window.dataLayer.push({
    //             'event': 'Video Play Btn',
    //             'formType': url,
    //             'formId': 'Video Play',
    //             'formName': 'Video',
    //             'formLabel': 'Video'
    //         });
    //     }
    // }

    var video_url2 = props?.videoUrl && getVideoId(props?.videoUrl);

    var get_file_extension = "";
    if(video_url2?.service){

    } else{
        if(props?.videoUrl){
            get_file_extension = props?.videoUrl.split('.').pop();
        }
    }

    const autpPlay = props?.videoUrl ? props?.videoUrl?.indexOf("?") > 0 ? "&play=1" : "?play=1" : ""

    //console.log("video_url ==>", video_url2, props?.videoUrl, get_file_extension);

    return (
        <React.Fragment>
            {/* <ModalVideo 
            channel='youtube' 
            key={props.key}
            autoplay 
            isOpen={props.isOpen} 
            videoId={props.videoId}
            autoplay={1}
            onClose={ e => props.isCloseFunction(false)}
            /> */}
            <Modal
                show={props.isOpen}
                onHide={() => props.isCloseFunction(false)}
                dialogClassName="modal-fullscreen modal-video"
                aria-labelledby="example-custom-modal-styling-title"
                backdropClassName="video-backdrop"
                fullscreen={fullscreen}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {video_url2 && 
                        video_url2?.service === "youtube" && !isMobile ?
                            <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${video_url2?.id}?autoplay=1`}  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        : 
                        video_url2?.service === "youtube" && isMobile ?
                            <ReactPlayer
                                url={`https://www.youtube.com/watch?v=${video_url2?.id}`}
                                width="100%"
                                height="100%"
                                playing
                                controls={false}
                                muted={false}
                            /> : 
                            video_url2?.service === "vimeo" ?
                                // <iframe width="100%" height="100%" src={`https://player.vimeo.com/video/${video_url2?.id}?autoplay=1`}  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                                <ReactPlayer
                                    url={`${props.videoUrl}`}
                                    width="100%"
                                    height="100%"
                                    playing
                                    controls={false}
                                    muted={false}
                                />
                                :
                                (get_file_extension === "mp4" || get_file_extension === "webm") ?
                                    <ReactPlayer
                                        url={`${props.videoUrl}`}
                                        width="100%"
                                        height="100%"
                                        playing
                                        controls={false}
                                        muted={false}
                                    />
                                :
                                    <iframe width="100%" height="100%" src={`${props.videoUrl}${autpPlay}`}  frameborder="0" allowfullscreen></iframe>
                    }
                </Modal.Body>
            </Modal>

        </React.Fragment>
    )

};

export default PlayVideo;